// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"00eea995","297":"e874ccde","453":"818e302b","454":"3addacf1","546":"c691eee7","664":"db6786a0","694":"7e47a29c","941":"e5497c2a","953":"e5067fbf"}[chunkId] + ".chunk.js";
};